
  import noneRuntime$QtDhWUfWfIE_45quZNApCYfQp5GHrHkImeZ_7FPxCDGTI from '/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/public/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.11.0_magicast@0.5.3_srvx@0.11.16/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime$_2GT7k0wQJRPUfxfLFViymsSiWbI8OpMK5giWIvl5g5I from '/home/snaumann/Development/public_html/konspirative-wohnungen-leipzig/api/vendors/gsmaterials/imgProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"none"} */
    provider: "none",
    providers: {
        ['none']: { setup: noneRuntime$QtDhWUfWfIE_45quZNApCYfQp5GHrHkImeZ_7FPxCDGTI, defaults: true },
  ['gs']: { setup: gsRuntime$_2GT7k0wQJRPUfxfLFViymsSiWbI8OpMK5giWIvl5g5I, defaults: undefined }
    }
  }
